import React, { useMemo, useRef, useContext } from "react";
import Button from "@acadia-ui/button";
import CreateCampaignV2 from "../../Modals/CreateCampaignV2";
import { ViewMasterCampaignsContext } from "../index";
import { DataTableContext } from "../Tabs/Overview";

export default () => {
	const dpRef = useRef();

	const { platforms, gridConfig, enabledPlatformAPIs, dataTableApi, permissionedDataKeys } = useContext(ViewMasterCampaignsContext);

	const Trigger = () => (
		<Button
			icon="icon-add"
			id="createMasterCampaign"
			display="primary"
			onClick={() => {
				dpRef?.current?.triggerOpenClose?.();
			}}
			data-tracking-id-alt="open-create-master-campaign-modal"
		>
			Primary Campaign
		</Button>
	);

	const DisplayedComponent = ({ dataProvider }) => {
		if (gridConfig && platforms) {
			return (
				<CreateCampaignV2
					onRef={(ref) => {
						dpRef.current = ref;
					}}
					config={gridConfig}
					mediaChannelsPlatforms={platforms}
					totalPlatforms={platforms?.length}
					enabledPlatformAPIs={enabledPlatformAPIs}
					reloadGrid={() => {
						dataTableApi?.current?.rowSelectionManager?.tree?.selectNode?.(false);
						setTimeout(() => {
							dataProvider.currentPage = 0;
							dataProvider.update();
						}, 1);
					}}
					permissionedDataKeys={permissionedDataKeys}
				/>
			);
		}
		return <></>;
	};

	return useMemo(() => ({ Trigger, DisplayedComponent }), [gridConfig, platforms, enabledPlatformAPIs]);
};
